import script from "./ProjectPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectPage.vue?vue&type=style&index=0&id=3db0f148&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db0f148"]])

export default __exports__